// extracted by mini-css-extract-plugin
export default {"absoluteDiv":"PartnerManagement_absoluteDiv__VKiTR","toastStyle":"PartnerManagement_toastStyle__ZKB1+"};